/**
 * Keep HTML controls usable alongside Unity's persistent WebGL runtime.
 * Install before Unity starts: its legacy keypress listener captures on window.
 * Modern keydown/up listeners bubble on window, so stop those on document only
 * after React's root handlers have received them. Never cancel native editing.
 */
export function installUnityKeyboardIsolation() {
  const isHtmlControl = (event: KeyboardEvent) => event.composedPath().some(
    target => target instanceof HTMLElement && (
      target.matches('input, textarea, select') || target.isContentEditable
    ),
  );

  const containBubblingKey = (event: KeyboardEvent) => {
    if (isHtmlControl(event)) event.stopPropagation();
  };
  const containLegacyKeypress = (event: KeyboardEvent) => {
    if (isHtmlControl(event)) event.stopImmediatePropagation();
  };

  document.addEventListener('keydown', containBubblingKey);
  document.addEventListener('keyup', containBubblingKey);
  window.addEventListener('keypress', containLegacyKeypress, true);

  return () => {
    document.removeEventListener('keydown', containBubblingKey);
    document.removeEventListener('keyup', containBubblingKey);
    window.removeEventListener('keypress', containLegacyKeypress, true);
  };
}
